import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IShopifyCustomer, IShopifyOrder } from '@app/_shared/_models';
import { CustomerService } from '../../_shared/_services/customer.service';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss'],
    imports: [MatChipListbox, MatChipOption, MatBadge, RouterLink, MatIcon, CurrencyPipe, DatePipe]
})
export class OrderComponent implements OnInit, OnDestroy {
  private readonly customerService = inject(CustomerService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  public order: IShopifyOrder | undefined;
  public customer$!: Observable<IShopifyCustomer | undefined>;
  public spinner$!: Observable<NgxSpinner>;
  private orderNumber: number | undefined;

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  public async ngOnInit(): Promise<void> {
    this.spinner$ = this.ngxSpinnerService.spinnerObservable;
    await this.ngxSpinnerService.show();
    this.customer$ = this.customerService.customer$;

    this.route.params.subscribe(params => {
      this.orderNumber = +params['id'];
    });

    this.customerService.customer$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (customer: IShopifyCustomer | undefined) => {
        if (customer?.orders !== undefined && this.orderNumber) {
          await this.ngxSpinnerService.hide();
          this.order = customer.orders?.find((x: IShopifyOrder) => x?.number === this.orderNumber);
        } else {
          await this.router.navigate(['/orders']);
        }
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
